import { Component } from "react";
import { Modal } from "react-bootstrap";
import { popCancelBttn } from "../../assets";
import Button from "../Button";
import './GlobalSearchFeaturesPopUp.css'
import './PubMedReviewListPopup.css'
import ApiServices from "../../utils/apiServices";
import { snippetLongString } from "../../utils/utilityServices";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
class RenamePubMedReviewListPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rlName: '',
            rlID: '',
            notes: '',
            showSuccess: false,
            showPop: false,
            error: '',
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            alertMessageIsError: false
        }
    }
    componentDidMount() {
        this.setState({
            showPop: this.props.showModal,
            rlName: this.props.rlName,
            rlID: this.props.rlID,
            notes: this.props.notes
        });
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true,
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true,
            alertMessageIsError: true
        })
    }
    closeAlertMessage = () => {
        const { alertMessageIsError, showPop } = this.state;
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            showPop: alertMessageIsError ? showPop : false,
            alertMessageShowModal: false,
            alertMessageIsError: false,
        })
        if (!alertMessageIsError) {
            this.props.handleClose(false)
        }
    }
    handleOnClickView = async (rlID, rName) => {
        let ids = "";
        //console.log({props: this.props})
        this.props.getAllReviewListData(rlID, "", rName)
        this.props.handleClose()
        //let service = new ApiServices();
        // console.log({rlID, rName})
        // let res = await fetch(`https://predev-ims.jnj.com${process.env.REACT_APP_IMS_API_PUBMED}reviewlist`, {
        //   method: 'POST',
        //   headers: {
        //     "Content-Type": "application/json"
        //   },
        //   body: JSON.stringify({
        //     "filters": "",
        //     "from_": 0,
        //     "size": 25,
        //     "sortBy": "",
        //     "sortField": "",
        //     "query": "",
        //     "reviewListId": rlID
        //   })
        // })
        // res = await res.json()
        // console.log({res})
        // let res = await service.getPubMedReviewDocIds(rlID);
        // console.log({res})
        // if (res.length > 0) {
        //   ids = res.map(item => item.doc_id).filter(x => x).join(";");
        //   // res.map((item) => {
        //   //   ids += `${item.doc_id};`;
        //   //   return null;
        //   // });
        // }
        localStorage.setItem("readListDocIds", ids);
        localStorage.setItem("rLID", rlID);
        localStorage.setItem("rName", rName);
        // let url = `/viewPubMedReviewList?query=&q=All%20Fields&filters=&f1=PMID&fval1=${ids}&fcount=1&rName=${encodeURIComponent(
        //   rName
        // )}&rID=${rlID}`;
        // if (ids !== "") {
        //   window.open(url, "_blank");
        // } else {
        //   this.errorAlertMessage("You do not have any items pinned to this review list.");
        // }
    };
    /*handleOnClickView = async (rlID, rName) => {

        let ids = "";
        let service = new ApiServices();
        let res = await service.getPubMedDocIds(rlID);
        if (res.length > 0) {
            ids = res.map(item=>item.doc_id).filter(x=>x).join(";");
            // res.map((item) => {
            //     ids += `${item.doc_id};`;
            //     return null;
            // });
        }
        localStorage.setItem("readListDocIds", ids);
        localStorage.setItem("rLID", rlID);
        localStorage.setItem("rName", rName);
        let url = `/viewPubMedReviewList?query=&q=All%20Fields&filters=&f1=PMID&fval1=${ids}&fcount=1&rName=${encodeURIComponent(
            rName
        )}&rID=${rlID}`;
        if (ids !== "") {
            window.open(url, "_blank");
        } else {
            this.errorAlertMessage("You do not have any items pinned to this review list.");
        }


        // let ids = '';
        // let service = new ApiServices
        // let res = await service.getDocIds(rlID);
        // if (res.length > 0) {
        //     res.map((item) => { ids += `${item.doc_id};`; return null })
        // }
        // let url = `/results?query=&q=All%20Fields&filters=&f1=searchID&fval1=${ids}&fcount=1`
        // window.open(url, '_blank');
    }*/
    handleSuccessClose = (status) => {
        this.setState({
            showSuccess: status
        })
    }
    handleSave = async () => {
        if (this.handleValidation()) {
            let service = new ApiServices();
            let res = await service.updatePubMedReviewListName(this.state.rlID, this.state.rlName, this.state.notes);
            if (res) {
                this.props.handleReviewNameTitle(this.state.rlName, this.state.rlID)
                this.successAlertMessage('Review List Name saved successfully');
            }
        }
    }
    handleInput = (e) => {
        e.target.value = snippetLongString(e.target.value);
        this.setState({
            rlName: e.target.value
        })
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        let reviewList = this.props.apiResponse.filter(x => x.reviewlist_id !== this.state.rlID).map(data => data.reviewlist_name.toLowerCase())
        if (this.state.rlName.length <= 0) {
            formIsValid = false;
            errors["pinReviewList"] = `Please enter a valid name to proceed.`;
        }
        if (reviewList.includes(this.state.rlName.toLowerCase())) {
            formIsValid = false;
            errors["pinReviewList"] = `You already have a review list with entered title. Please enter a new name.`;
        }
        this.setState({ error: errors });
        return formIsValid;
    }
    render() {
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        if (this.props.width <= 1000) {
            return (
                <>
                    <Modal
                        show={this.state.showPop}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="popup-transition"
                        scrollable={true}
                    >
                        <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                            <div>
                                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left", padding: "0.5rem 0" }}>
                                    <div style={{ textAlign: "center", width: "100%", paddingTop: "1%" }}>
                                        <Modal.Title>
                                            <div className="actionItem-headerPart">
                                                Rename Review List
                                            </div>
                                        </Modal.Title>
                                    </div>
                                </Modal.Header>
                                <Modal.Body scrollable={true} style={{ minHeight: "25vh" }}>
                                    <table className="review-list-view-wrapper">
                                        <tr><th>Review List Name</th></tr>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "60%" }}><input type="text" value={this.state.rlName} onChange={this.handleInput} /><br /><div className="errorInvalidName">{this.state.error["pinReviewList"]}</div></td>
                                                <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}>
                                                    {/*<span onClick={e => this.handleOnClickView(this.props.rlID, this.props.rlName)} title="View" style={{ marginRight: "5px" }} className="review-list-action-text">View</span>
                                                <span className="action-items-separate-divider"></span>*/}
                                                    <span title="Save" onClick={e => this.handleSave()} className="review-list-action-text">Save</span>
                                                </td>
                                            </tr>
                                            <span className="length-info">Name with a maximum of 100 characters.</span>
                                            <div className="review-list-notes-label">
                                                Review List Notes
                                            </div>
                                            <textarea
                                                className="create-alert-text-area"
                                                placeholder="Enter your custom notes here."
                                                onChange={(e) => this.setState({ notes: e.target.value })}
                                                value={this.state.notes}
                                            ></textarea>
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                <div className="review-list-button-tablet-wrapper">
                                    <div style={{ width: "60%", display: "flex", justifyContent: "space-between" }}>
                                        <Button text="Save" customColor="#0074B0" action={() => {
                                            this.handleSave()
                                        }} />
                                        <Button text="Cancel" customColor="#000000" action={() => {
                                            this.setState({ showPop: false });
                                            this.props.handleClose(false);
                                        }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                </>
            )
        }
        else {
            return (
                <>
                    <Modal
                        show={this.state.showPop}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="popup-transition"
                        scrollable={true}
                    >
                        <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                            <div className="popup-cancel-btn-wrapper">
                                <img
                                    src={popCancelBttn}
                                    alt=""
                                    onClick={e => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }}
                                />
                            </div>
                            <div>
                                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left" }}>
                                    <div style={{ textAlign: "center", width: "30%", paddingTop: "1%" }}>
                                        <Modal.Title>
                                            <div className="actionItem-headerPart">
                                                Rename Review List
                                            </div>
                                        </Modal.Title>
                                    </div>
                                </Modal.Header>
                                <Modal.Body scrollable={true} style={{ minHeight: "25vh" }}>
                                    <table className="review-list-view-wrapper">
                                        <tr><th>Review List Name</th>{/*<th style={{ textAlign: "center" }}>Actions</th>*/}</tr>
                                        <tbody>
                                            <tr>
                                                <td><input type="text" className="create-alert-text-box" value={this.state.rlName} onChange={this.handleInput} /><br />
                                                    <div className="errorInvalidName">{this.state.error["pinReviewList"]}</div>
                                                </td>
                                                <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}>
                                                    {/*<span onClick={e => this.handleOnClickView(this.props.rlID, this.props.rlName)} title="View" style={{ marginRight: "5px" }} className="review-list-action-text">View</span>
                                                    <span className="action-items-separate-divider"></span>
                                                    <span title="Save" onClick={e => this.handleSave()} className="review-list-action-text">Save</span>*/}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <span className="length-info">Name with a maximum of 100 characters.</span>
                                        <tr><th> Review List Notes</th></tr>
                                        <tbody>
                                            <tr>
                                                <td> <textarea
                                                    className="create-alert-text-area"
                                                    placeholder="Enter your custom notes here."
                                                    onChange={(e) => this.setState({ notes: e.target.value })}
                                                    value={this.state.notes}
                                                ></textarea>
                                                </td>
                                                <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                <div className="review-list-button-wrapper" style={{ float: "none", width: "100%", justifyContent: "end" }}>
                                    <div className="review-list-wp">
                                        <Button text="Save" customColor="#0074B0" action={() => {
                                            this.handleSave()
                                        }} />
                                        <Button text="Cancel" customColor="#000000" action={() => {
                                            this.setState({ showPop: false });
                                            this.props.handleClose(false);
                                        }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                </>
            )
        }
    }
}
export default RenamePubMedReviewListPopup;